"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageRoutes = void 0;
var ChatMessageRoutes;
(function (ChatMessageRoutes) {
    ChatMessageRoutes["BasePrefix"] = "chat-messages";
    ChatMessageRoutes["ById"] = ":chatMessageId";
    ChatMessageRoutes["AllByChat"] = "all/:chatId";
    ChatMessageRoutes["List"] = "list";
    ChatMessageRoutes["File"] = "file";
})(ChatMessageRoutes = exports.ChatMessageRoutes || (exports.ChatMessageRoutes = {}));
